//main
import ContentFormatXX from '../content/webc/content-format-xx';

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import AccountsLinkModule from '../content/accounts/accounts-link';

import { UserForm } from "../services/srvc-utilities";

export default function AccountsLink() {

  return (
  <>
    <ContentFormatXX 
      head='Link Account'
      link={`/${UserForm()}/home`}
      form= 'mini'
      data= {
        <>
          <WebbDividerSmall />
          <AccountsLinkModule />


        </>
      } 
    />
  </>
  )
}